import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlankOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CheckBoxOutlineBlankOutlined.js
// module id = 2756
// module chunks = 2